import React, { useEffect } from "react";
import CardForms from "../../components/Card/CardForms";
import Grid from "@material-ui/core/Grid";
import Button from "components/CustomButtons/Button.js";
import { makeStyles } from "@material-ui/core/styles";
import SnackBarWiiba from "components/Snackbar/SnackBarWiiba";
import SearchDevelopment from "../../components/Desarrollo/SearchDevelopment";
import SelectBlocks from "../../components/Manzanas/SelectBlocks";
import TableLot from "../../components/Lotes/TableLot";
import InputLot from "../../components/Lotes/InputLot";
import useMessage from "../../hooks/useMessage";
import useDevelop from "../../hooks/useDevelop";
import useBlocks from "../../hooks/useBlocks";
import useLot from "../../hooks/useLot";
import EmptyState from "../../components/EmptyState/EmptyState";
import ViewModuleIcon from "@material-ui/icons/ViewModule";

const useStyles = makeStyles(theme => ({
  filtersSection: {
    marginBottom: theme.spacing(3),
  },
  btnContainer: {
    display: "flex",
    alignItems: "flex-end",
    paddingBottom: theme.spacing(0.5),
  },
}));

const CoreBlocks = () => {
  const classes = useStyles();
  const desarrolloGuardado = sessionStorage.getItem("desarrollo_seleccionado");
  const desarrolloInicial = desarrolloGuardado ? JSON.parse(desarrolloGuardado) : null;
  const [developmentSelected, setDevelopmentSelected] = React.useState(!!desarrolloInicial);

  const {
    opensnack, typesnackbar, message,
    handleMuestraSnack, handleClosesSnack
  } = useMessage();

  const { developments, getDevelopments } = useDevelop({ handleMuestraSnack });
  const {
    lot, getLots, handleClickSave, handleDeleteLot,
    numlot, handleInputSave, handleInput
  } = useLot({ handleMuestraSnack });

  const { getBlocks, blocks, idBlock, onChangeBlock, deleteBlock } = useBlocks({
    handleMuestraSnack, handleInput, getLots
  });

  const [currentDev, setCurrentDev] = React.useState(desarrolloInicial);

  const handleDevelopmentChange = (value) => {
    setDevelopmentSelected(!!value);
    setCurrentDev(value);
    getBlocks(value);
  };

  const handleDeleteManzana = () => {
    if (!idBlock || idBlock <= 0) return;
    if (!window.confirm("¿Está seguro de eliminar esta manzana?")) return;
    deleteBlock(idBlock, currentDev);
  };

  useEffect(() => {
    getDevelopments();
    if (desarrolloInicial) {
      getBlocks(desarrolloInicial);
      sessionStorage.removeItem("desarrollo_seleccionado");
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <SnackBarWiiba
        opensnack={opensnack}
        tipoSnackBar={typesnackbar}
        mensaje={message}
        handleClosesSnack={handleClosesSnack}
      />
      <CardForms title={"Gestión de lotes por manzana"}>
        {/* Filtros */}
        <Grid container spacing={3} className={classes.filtersSection} alignItems="flex-end">
          <Grid item xs={12} sm={4} md={3}>
            <SearchDevelopment
              developments={developments}
              onChange={handleDevelopmentChange}
              defaultValue={desarrolloInicial}
            />
          </Grid>
          {developmentSelected && (
            <Grid item xs={12} sm={4} md={3}>
              <SelectBlocks
                onChange={onChangeBlock}
                blocks={blocks}
                idBlock={idBlock}
              />
            </Grid>
          )}
          {developmentSelected && idBlock > 0 && (
            <Grid item xs="auto" className={classes.btnContainer}>
              <Button onClick={handleDeleteManzana} color="danger" size="sm">
                Eliminar manzana
              </Button>
            </Grid>
          )}
          {developmentSelected && idBlock > 0 && (
            <Grid item xs={6} sm={2} md={2}>
              <InputLot onChange={handleInput} numlots={numlot} />
            </Grid>
          )}
          {developmentSelected && idBlock > 0 && numlot > 0 && (
            <Grid item xs={6} sm={2} md={2} className={classes.btnContainer}>
              <Button
                onClick={e => handleInputSave(e, idBlock, numlot)}
                color="success"
              >
                Crear lotes
              </Button>
            </Grid>
          )}
        </Grid>

        {/* Tabla */}
        {developmentSelected ? (
          <TableLot
            blocks={blocks}
            idBlock={idBlock}
            lot={lot}
            handleClickSave={handleClickSave}
            handleDeleteLot={handleDeleteLot}
            getLots={getLots}
          />
        ) : (
          <EmptyState
            message="Selecciona un desarrollo para ver las manzanas y sus lotes"
            icon={ViewModuleIcon}
          />
        )}
      </CardForms>
    </>
  );
};

export default CoreBlocks;
